// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-fade {
  &.swiper-free-mode {
    .swiper-slide {
      transition-timing-function: ease-out;
    }
  }
  .swiper-slide {
    pointer-events: none;
    transition-property: opacity;
    .swiper-slide {
      pointer-events: none;
    }
  }
  .swiper-slide-active {
    pointer-events: auto;
    & .swiper-slide-active {
      pointer-events: auto;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/swiper/modules/effect-fade.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,oCAAoC;IACtC;EACF;EACA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B;MACE,oBAAoB;IACtB;EACF;EACA;IACE,oBAAoB;IACpB;MACE,oBAAoB;IACtB;EACF;AACF","sourcesContent":[".swiper-fade {\n  &.swiper-free-mode {\n    .swiper-slide {\n      transition-timing-function: ease-out;\n    }\n  }\n  .swiper-slide {\n    pointer-events: none;\n    transition-property: opacity;\n    .swiper-slide {\n      pointer-events: none;\n    }\n  }\n  .swiper-slide-active {\n    pointer-events: auto;\n    & .swiper-slide-active {\n      pointer-events: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
